import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BasicModalOperationResult, DialogModalComponent, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { DismissReason } from 'src/app/shared/extensions/ng-active-modal/dismiss-reason';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DefaultDocumentProcessTo, DocumentProcessTo } from 'src/app/core/models/document-process-to.model';
import { DocumentProcess } from 'src/app/core/models/document-process.model';
import { Observable } from 'rxjs';
import { InviteService } from 'src/app/core/services/api/invite.service';
import { NewUserDocumentProcessTo} from 'src/app/core/models/newUserDocumentProcessTo-model';
import { Invite } from 'src/app/core/models/invite-model';

@Component({
  selector: 'app-upload-new-invite',
  templateUrl: './upload-new-invite.component.html',
  styleUrls: ['./upload-new-invite.component.scss']
})
export class UploadNewInviteComponent implements OnInit {
  @Input() public newUserDocumentProcessTo: NewUserDocumentProcessTo;
  hasSubmittedData: boolean = false;
  invite: Invite;

  constructor(
    public translate: TranslateService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private inviteService: InviteService
  ) { }

  ngOnInit(): void {    
    
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    let hasPendingChanges = this.hasPendingChanges();
    let canLeave =
      !hasPendingChanges || (hasPendingChanges && this.hasSubmittedData);
    return canLeave;
  }

  isAbleToUpload() {
    let isValidToSave = false;

    if (

        this.newUserDocumentProcessTo.firstName != '' &&
        this.newUserDocumentProcessTo.lastName  != '' &&
        this.newUserDocumentProcessTo.Email  != '' &&
        this.newUserDocumentProcessTo.sintraId  != ''

    ) {
      isValidToSave = true;
    }

    return isValidToSave;
  }

  hasPendingChanges() {
    let hasPendingChanges =
        (this.newUserDocumentProcessTo.firstName != '') ||
        ( this.newUserDocumentProcessTo.lastName != '') ||
        (this.newUserDocumentProcessTo.Email != '') ||
      (this.newUserDocumentProcessTo.sintraId
        )
    return hasPendingChanges;
  }

  closeModal() {
    if (this.hasPendingChanges()) {
      const modalRef = this.modalService.open(DialogModalComponent, {
        backdrop: "static",
        keyboard: false,
      });

      const modalInstance =
        modalRef.componentInstance as IBasicModalComponentInstance;
      modalInstance.title = this.translate.instant(
        "pendingChangesGuard.modalTitle"
      );
      modalInstance.type = BasicModalOperationResult.Warning;
      modalInstance.body = this.translate.instant(
        "pendingChangesGuard.modalBody"
      );
      modalInstance.buttons = [
        {
          text: this.translate.instant("pendingChangesGuard.cancel"),
          cssClass: "btn btn-outline-dark",
          handler: async (btn) => {
            modalInstance.closeModal();
          },
        },
        {
          closeModalOnClick: false,
          text: this.translate.instant("pendingChangesGuard.accept"),
          cssClass: "btn btn-success",
          handler: (btn) => {
            modalInstance.closeModal();
            this.activeModal.close(DismissReason.Cancelled);
          },
        },
      ];
    } else {
      this.activeModal.close(DismissReason.Cancelled);
    }
    }

   async uploadInvite()
    {

      await this.inviteService.inviteValidator(this.newUserDocumentProcessTo);
      this.activeModal.close(this.newUserDocumentProcessTo);
    
    }
}
